// extracted by mini-css-extract-plugin
export var avatarContainer = "_8i-0";
export var avatarTypingWave = "_8i-i";
export var gray = "_8i-f";
export var green = "_8i-c";
export var icon = "_8i-9";
export var image = "_8i-1";
export var lg = "_8i-6";
export var md = "_8i-5";
export var presenceDot = "_8i-b";
export var red = "_8i-d";
export var sm = "_8i-4";
export var status = "_8i-a";
export var typingDot = "_8i-h";
export var typingPill = "_8i-g";
export var xl = "_8i-7";
export var xs = "_8i-3";
export var xxl = "_8i-8";
export var xxs = "_8i-2";
export var yellow = "_8i-e";